/**
 * Moment plugin
 *
 * See more https://momentjs.com/
 *
 * @type {{install(*, *): void}}
 */

import moment from 'moment'

const MomentPlugin = {

    install(app, options) {

        app.config.globalProperties.$moment = moment;

        // Locale
        let lang = localStorage.getItem('lang');
        lang = lang === 'pt-BR' ? 'pt_br' : lang;
        //force format DD/MM/YYYY
        moment.updateLocale(lang, {
            longDateFormat: {
                L: 'DD/MM/YYYY'
            }
        });
        moment.updateLocale('en', {
            longDateFormat: {
                L: 'MM/DD/YYYY'
            }
        });
        app.config.globalProperties.$moment.locale(lang);

    }
}

export default MomentPlugin;
